import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { isBrowser } from "./browser"
import { RuntimeConfigType, getServerRuntimeConfig } from "./runtimeConfig"

export enum Environment {
    Development = "development",
    Production = "production",
}

const getEnvironment = (envVar: Maybe<string>): Environment => {
    if (envVar === "production") {
        return Environment.Production
    } else {
        return Environment.Development
    }
}

export type ConfigType = {
    environment: Environment
    devMode: boolean
    graphqlBaseUrl: string
    webApiBaseUrl: string
    googleApiKey: string
    appUrl: string
    manageNewUrl: string
    mibBaseUrl: string
    googleAnalyticsTrackingId: string
    datadogClientToken: string
    bugSnagClientToken: string
    fishjamId: string
}

/**
 * Get runtime config - from window on client, from env vars on server
 */
const getRuntimeConfig = (): RuntimeConfigType["publicRuntimeConfig"] => {
    if (isBrowser && window.__RUNTIME_CONFIG__) {
        return window.__RUNTIME_CONFIG__
    }
    return getServerRuntimeConfig().publicRuntimeConfig
}

const runtimeConfig = getRuntimeConfig()

export const Config: ConfigType = {
    environment: getEnvironment(runtimeConfig.environment),
    devMode: process.env.NODE_ENV !== "production",
    graphqlBaseUrl: `${runtimeConfig.apiBaseUrl}/manage-api/graphql`,
    webApiBaseUrl: `${runtimeConfig.apiBaseUrl}/manage-api/http`,
    googleApiKey: runtimeConfig.googleApiKey,
    appUrl: runtimeConfig.appUrl,
    manageNewUrl: runtimeConfig.manageNewUrl,
    mibBaseUrl: runtimeConfig.mibBaseUrl,
    googleAnalyticsTrackingId: runtimeConfig.googleAnalyticsTrackingId,
    datadogClientToken: runtimeConfig.datadogClientToken,
    bugSnagClientToken: runtimeConfig.bugSnagClientToken,
    fishjamId: runtimeConfig.fishjamId,
}
